import React from 'react';
import { pointExcelUpload } from '@/api/point/create';
import { CreateExcelUploadRowType } from '@/types';
import ExcelUploadBase from './ExcelUploadBase';

export default function ExcelPointUpload() {
  return (
    <ExcelUploadBase<CreateExcelUploadRowType>
      dataType="포인트"
      onUpload={pointExcelUpload}
      otpTitle="포인트 업로드 인증"
      otpDescription="포인트 업로드를 위해 OTP 인증이 필요합니다."
    />
  );
}
